import { Tooltip, useMediaQuery, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

import { tooltipStyled } from './TrlTooltip.styles';

export const TrlTooltip = ({ text, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Tooltip
      title={text}
      enterTouchDelay={isMobile ? 0 : 700}
      leaveTouchDelay={isMobile ? 3000 : 1500}
      slotProps={{
        tooltip: {
          sx: tooltipStyled(theme),
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

TrlTooltip.propTypes = {
  text: PropTypes.string,
  children: PropTypes.node.isRequired,
};
